"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LongRunningTaskType = exports.LongRunningTaskStatus = void 0;
exports.LongRunningTaskStatus = {
    RUNNING: 'running',
    COMPLETED: 'completed',
    COMPLETED_WARNINGS: 'completed-warnings',
    COMPLETED_ERRORS: 'completed-errors',
    FAILED: 'failed',
};
exports.LongRunningTaskType = {
    EXPORT: 'export',
};
//# sourceMappingURL=long-running-task.js.map